import PropTypes, { number } from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    Input,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"
import { Controller, useForm } from "react-hook-form";
import axios from "axios"
import { MultiSelect } from "primereact/multiselect"
//i18n
import { Link, useNavigate } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import { FileUpload } from 'primereact/fileupload';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dropdown } from 'primereact/dropdown';
import { InputText, InputTextarea } from 'primereact';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { TreeSelect } from "primereact/treeselect";
import { Checkbox } from "primereact/checkbox";
import { Editor } from "primereact/editor";
import Select from 'react-select';
import moment from "moment";

const Jobsdetails = props => {


    const [selectedprimarySkills, setselectedprimarySkills] = useState([]);

    const [selectedSkillsSecondary, setselectedSkillsSecondary] = useState([]);

    const getskills = async () => {
        try {

            const response = await axios.get(`/api/v1/get-all-skills/`, {
            });
            console.log(response.data)
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((workv) => ({
                name: workv.skill_name,
                id: workv.skill_id,
            }));
            setSkillsOptions(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };




    // toast msg

    const toast = useRef(null);


    const [otherSkillsval, setotherSkillsval] = useState([])
    const [secondarySkillsval, setsecondarySkillsval] = useState([])
    const [primarySkillsvalu, setprimarySkillsvalu] = useState([])



    const [selectedJobFunction, setSelectedJobFunction] = useState(null);
    const [jobFunctions, setjobFunctions] = useState([])

    const [selectedSeniority, setSelectedSeniority] = useState(null);
    const [seniorityLevels, setseniorityLevels] = useState([]);


    const getfunctionview = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-jobfunction-type/`, {

            });

            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((jobtypes) => ({
                name: jobtypes.jobfunction_type,
                id: jobtypes.id,
            }));
            setjobFunctions(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };


    const getsentrory = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-seniority-level/`, {

            });

            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((sen) => ({
                name: sen.seniority_level,
                id: sen.id,
            }));
            setseniorityLevels(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };
    useEffect(() => {
        getsentrory()
        getfunctionview()

    }, [])


    const [jobworkspace, setjobworkspace] = useState(null);
    const [jobworkspaceview, setjobworkspaceview] = useState([]);

    const [jobtype, setjobtype] = useState(null);
    const [jobjobtypeview, setjobjobtypeview] = useState([]);

    const getworkspace = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-workplace-type/`, {

            });
            console.log(response.data)
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((workv) => ({
                name: workv.workplace_type,
                id: workv.id,
            }));
            setjobworkspaceview(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    const getjoptype = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-Job-types/`, {

            });

            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((jobtypes) => ({
                name: jobtypes.job_type,
                id: jobtypes.id,
            }));
            setjobjobtypeview(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    const getDepartments = async () => {

        try {
            const response = await axios.get(`/api/v1/get-all-departments/`, {

            });
            if (response.data) {

                const transformedData = response.data.results.map((dept) => ({
                    name: dept.name,
                    id: dept.department_id,
                }));
                setdepartitems(transformedData);
            }
        } catch (error) {

        }
    };


    useEffect(() => {
        getworkspace()
        getjoptype()
    }, [])


    const [jobLocations, setjobLocations] = useState([])
    const [companies, setcompanies] = useState([])


    const getcity = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-cities/`, {

            });
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.city_id,
            }));
            setjobLocations(transformedData);

        }
        catch (error) {
        }
    };
    const getCompany = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-companies/`, {

            });
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((company) => ({
                name: company.company_name,
                id: company.company_id,
            }));
            setcompanies(transformedData);


        }
        catch (error) {
        }
    };
    useEffect(() => {
        getcity()
        getCompany()
    }, [])





    const [jobStatusview, setjobStatusview] = useState([]);

    const getjobstatus = async () => {

        try {
            const response = await axios.get(`/api/v1/get-all-Job-status/`, {});
            const transformedData = response.data.results.map((jobstu) => ({
                name: jobstu.job_status,
                id: jobstu.id,
            }));
            setjobStatusview(transformedData);
        } catch (error) {

        }
    };

    useEffect(() => {
        getjobstatus()
    }, [])


    useEffect(() => {

        getskills()

    }, [])








    const getHirringmanager = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-hiring-managers/`, {

            });
            const transformedData = response.data.results.map((company) => ({
                name: company.first_name,
                id: company.id,
            }));
            sethiringManagers(transformedData);

        } catch (error) {

        }
    };


    const [departitems, setdepartitems] = useState([])
    const [departitemsval, setdepartitemsval] = useState(null)
    const [hiringManagers, sethiringManagers] = useState([])


    useEffect(() => {
        getHirringmanager()
        getDepartments()
    }, []);


    /////////////////////

    const [formValues, setFormValues] = useState([{ section1: "" }]);

    const [questionError, setQuestionError] = useState(null);

    const handleChange = (index, field, value) => {
        // Clone the current form values
        const newFormValues = [...formValues];

        // Ensure the object at the specified index exists
        if (newFormValues[index]) {
            newFormValues[index][field] = value; // Update the field
            if (field === "qualification" && typeof value === "string") {
                value = value.trim();  // Only trim if it's a string
            }// Set error flag
            setFormValues(newFormValues); // Update the state
        } else {
        }
    };
    let addFormFields = () => {
        setQuestionError('');
        setFormValues([...formValues, { section1: "", idealAnswer: "", qualification: false, skills: "", is_deleted: false, haveError: false }]);
        // console.log(formValues,'formValues on add click')
    };
    const removeFormFields = async (question_id) => {
        try {
            // Step 1: Mark the field as deleted in local state
            const newFormValues = formValues.map((item) =>
                item.question_id === question_id ? { ...item, is_deleted: true } : item
            );
            setFormValues(newFormValues);

            // Step 2: Make the API call to delete the entry
            const response = await axios.delete(
                `/api/v1/screening-questions/${question_id}/`
            );

            // Step 3: If successful, update state and refresh data
            if (response.status === 200) {
                setSmShow(false);
                getAllActive(pageState.page, pageState.rows); // Refresh data
                setSuccessAlert(true); // Show success alert
            }
        } catch (error) {
            // Handle errors gracefully
            console.error("Error deleting field:", error);
        }
    };


    const [openings, setOpenings] = useState(null);
    const [minSalary, setMinSalary] = useState(null);
    const [maxSalary, setMaxSalary] = useState(null);
    const [jobStatus, setJobStatus] = useState(null);

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    };

    const header = renderHeader();

    const [content, setContent] = useState("");
    const maxWords = 500;

    // Function to calculate word count
    const calculateWordCount = (text) => {
        const words = text
            .trim()
            .replace(/<[^>]*>/g, "") // Remove HTML tags
            .split(/\s+/); // Split by whitespace
        return words.filter((word) => word).length; // Filter out empty words
    };

    // Current word count
    const currentWordCount = calculateWordCount(content);

    // Handle editor input
    const handleEditorChange = (e) => {
        const text = e.htmlValue || ""; // Get the HTML content
        if (calculateWordCount(text) <= maxWords) {
            setContent(text); // Only update content if within word limit
        }
    };

    //skills

    const [skillsOptions, setSkillsOptions] = useState([]);

   
   
    const handleCloseDialog = () => {
        setShowDialog(false); // Close the dialog
    };
    const [showDialog, setShowDialog] = useState(false);
    // State to hold the submitted data
    const [submittedData, setSubmittedData] = useState({});


    const [activeIndex, setActiveIndex] = useState(0);
    const [validationError, setValidationError] = useState("");

    // Basic Info
    const [jobId, setJobId] = useState("");
    const [jobtitle, setJobtitle] = useState("");
    const [totalExperience, setTotalExperience] = useState(null);

    // Hiring Details
    const [selectedManager, setSelectedManager] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);

    // Sample Options



    const jobTitleRegex = /^[a-zA-Z0-9\s\-_,.\/]+$/;

    const nextTab = () => {
        if (activeIndex === 0) {
            if (!jobtitle || !jobTitleRegex.test(jobtitle)) {
                setValidationError("Job Title are required ");
                return;
            }
            // if (totalExperience === null || totalExperience === "") {
            //     setValidationError("Experience Required is mandatory.");
            //     return;
            // }
            setFormData((prev) => ({
                ...prev,
                jobtitle: jobtitle,
                experience: totalExperience
            }));

            setValidationError("");
            setActiveIndex(1);
        } else if (activeIndex === 1) {
            if (!selectedManager) {
                setValidationError("Hiring Manager are required.");
                return;
            }
            setValidationError("");
            setActiveIndex(2);
        } else {
            setValidationError("");
            setActiveIndex((prev) => prev + 1);
        }
    };

    const previousTab = () => {
        setValidationError("");
        setActiveIndex((prev) => Math.max(prev - 1, 0));
    };



    const [formData, setFormData] = useState({});
    const basicinformation = [
        { key: "jobtitle", label: "Job Title" },
        { key: "jobStatus", label: "job Status" },
        { key: "openings", label: "Number of Openings" },
        { key: "experience", label: "Experience Required", suffix: " years" },
    ];

    const location = [
        { key: "location", label: "Location" },
        { key: "manager", label: "Hiring Manager" },
        { key: "company", label: "Company" },
    ]

    const hiringdetailes = [
        { key: "department", label: "Department" },
        { key: "minSalary", label: "Minimum Salary", prefix: "₹" },
        { key: "maxSalary", label: "Maximum Salary", prefix: "₹" },
        { key: "jobType", label: "Job Type" },
        { key: "workplaceType", label: "Workplace Type" },

    ]

    const jobdescription = [
        { key: "content", label: "Description" },
    ]
    const jobskills = [
        { key: "skillsPrimary", label: "Primary Skills", isArray: true },
        { key: "skillsSecondary", label: "Secondary Skills", isArray: true }
    ];
    const getSkillNames = (ids) => {
        return skillsOptions
            .filter((skill) => ids.includes(skill.id))
            .map((skill) => skill.name);
    };

    const handleSubmit1 = () => {

        setShowDialog(true);

        const mappedQuestions = formValues
            .filter(q => !q.is_deleted && q.section1 && q.idealAnswer) // ✅ filter out empty/incomplete ones
            .map(q => ({
                question: q.section1,
                skill: q.skills,
                experience: q.idealAnswer,
                qualification: q.qualification
            }));

        const collectedData = {
            jobtitle,
            jobId: jobId,
            openings,
            experience: totalExperience,
            manager: selectedManager?.name || selectedManager,
            jobStatus: jobStatus?.name || jobStatus,
            company: selectedCompany?.name || selectedCompany,
            location: selectedLocation?.name || selectedLocation,
            department: departitemsval?.name || departitemsval,
            minSalary,
            maxSalary,
            jobType: jobtype?.name || jobtype,
            jobworkspace: jobworkspace?.name || jobworkspace,
            content: content,
            skillsPrimary: getSkillNames(selectedprimarySkills),
            skillsSecondary: getSkillNames(selectedSkillsSecondary),
            jobFunction: selectedJobFunction?.name || selectedJobFunction,
            seniority: selectedSeniority?.name || selectedSeniority,



            screeningQuestions: mappedQuestions,
        };
        setFormData(collectedData);  // Save

    };
    const fileUploadRef = useRef(null);
    const [fileData, setFileData] = useState([]);
    const [error, setError] = useState("");
    const [resumefileData, setResumeFileData] = useState([]);
    const handleSubmit = async () => {
        let req = {

        };
        if (jobId) {
            req.JobId = jobId;
        }
        if (jobtitle) {
            req.job_title = jobtitle;
        }
        if (jobStatus) {
            req.jobStatus = jobStatus.id;
        }
        if (selectedManager) {
            req.hiring_manager = selectedManager.id;
        }
        if (departitemsval) {
            req.department = departitemsval.id;
        }

        if (statusjob) {
            req.status = statusjob.id;
        }
        if (openings) {
            req.openings = openings;
        }
        if (totalExperience) {
            req.required_experience = totalExperience;
        }
        if (selectedCompany) {
            req.company_id = selectedCompany.id;
        }
        if (selectedLocation) {
            req.location = selectedLocation.id;
        }
        if (jobworkspace) {
            req.workplace_types = jobworkspace.id;
        }
        if (jobtype) {
            req.job_type = jobtype.id;
        }
        if (minSalary) {
            req.salary_min = minSalary;
        }
        if (maxSalary) {
            req.salary_max = maxSalary;
        }
        if (description) {
            req.job_notes = description;
        }

        if (selectedSkillsSecondary) {
            req.preferred_skills = selectedSkillsSecondary;
        }
        if (selectedprimarySkills) {
            req.required_skills = selectedprimarySkills;
        }
        if (selectedJobFunction) {
            req.job_function = selectedJobFunction;
        }
        if (selectedSeniority) {
            req.seniority = selectedSeniority;
        }
        if (resumefileData) {
            req.attachments = resumefileData
        }





        if (content) {
            req.job_description = content;
        }
        const validQuestions = formValues.filter(
            (question) =>
                !question.is_deleted &&
                (question.section1 || question.skills || question.idealAnswer || question.qualification)
        );

        if (validQuestions.length > 0) {
            req.screening_questions = validQuestions.map((question) => ({
                question_text: question.section1,
                question_id: question.question_id || undefined,
                is_deleted: question.is_deleted,
                skill: question.skills,
                ideal_answer: question.idealAnswer,
                must_have_qualification: question.qualification || false,
            }));
        }

        try {
            const response = await axios.post("/api/v1/jobs/", req);
            if (response.status === 201 || response.status === 200) {
                alert("Job created successfully!");
            }
        } catch (error) {

        }
    };


    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        // Validate file type
        const allowedTypes = ["application/pdf"];
        if (!allowedTypes.includes(file.type)) {
            setError(" PDF files are allowed.");
            return;
        }
        // Validate file size (max 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            setError("File size should not exceed 10MB.");
            return;
        }
        setError(""); // Clear errors
        try {
            const base64 = await getBase64(file);
            const base64withoutPrefix = base64?.split(",")[1]
            setResumeFileData(base64withoutPrefix); // Store only base64 content
        } catch (error) {
            console.error(error);
            setError("Error while converting file to base64.");
        }
    };




    return (
        <React.Fragment>
            <header id="page-topbar">
                <div className="navbar-header candidate-form">
                    <Container fluid={true}>
                        <Row className="align-items-center justify-content-between">
                            <Col lg={8}>
                                <div className="d-flex">
                                    {/* <div className="navbar-brand-box">
                                        <Link to="/" className="logo logo-dark">
                                            <span className="logo-sm">
                                                <img src={AtsImg} height="50" />
                                            </span>
                                            <span className="logo-lg">
                                                <img src={AtsImg} height="50" />
                                            </span>
                                        </Link>

                                        <Link to="/" className="logo logo-light">
                                            <span className="logo-sm favicon-logo">
                                                <img src={AtsImg} alt="" height="50" />
                                            </span>
                                            <span className="logo-lg barath-logo">
                                                <img src={AtsImg} alt="" height="50" />
                                            </span>
                                        </Link>
                                    </div> */}
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="d-flex justify-content-end">
                                    <p className="me-3">Home</p>
                                    <p>Help</p>
                                </div>
                            </Col>

                        </Row>
                    </Container>
                </div>
            </header>
            <div className="page-content candidate-form">
                <Container fluid={true}>
                    <Row>
                        <Col lg={12}>
                            <h3 className="candet-head">Job Details Form</h3>
                        </Col>
                        <Col lg={4}>
                            <h5>Upload Job Description</h5>
                            <div className="">
                                <Col lg={12}>

                                    <input
                                        type="file"
                                        accept="image/jpg,image/jpeg,image/png,application/pdf"
                                        className="form-control addEmp_ProfilePhoto"
                                        id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                                        onChange={handleFileChange}
                                    />
                                    {error && <small className="text-danger">{error}</small>}
                                    <small className="text-muted">
                                        {/* Eg: (jpeg,png,pdf,jpg) */}
                                    </small>
                                </Col>
                                {/* <FileUpload
                                    ref={fileUploadRef}
                                    name="emailAttachments[]"
                                    mode="basic"
                                    accept=".pdf"
                                    // customUpload
                                    uploadHandler={onUploadHandler}
                                    className="file-upload-input"
                                />

                                {error && <small className="text-danger">{error}</small>} */}

                            </div>
                        </Col>
                    </Row>
                    <Row className="tabs">
                        <Col>
                            <TabView className="tabview-sett" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                <TabPanel header="Basic Information" leftIcon="pi pi-info-circle mr-2">
                                    <Row className="mb-3">
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="jobId" className="block">Job ID</label>
                                                <InputText id="jobId" value={jobId} onChange={(e) => { setJobId(e.target.value) }} className="w-full" />

                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <label>Job Title</label>
                                            <InputText value={jobtitle} onChange={(e) => { setValidationError(""); setJobtitle(e.target.value) }} className="w-full" />
                                            <small className="text-danger">{validationError.includes("Job Title") && validationError}</small>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="jobStatus" className="block">Job Status</label>
                                                <Dropdown
                                                    id="jobStatus"

                                                    value={jobStatus}
                                                    options={jobStatusview}
                                                    onChange={(e) => { setJobStatus(e.value) }}
                                                    optionLabel="name"

                                                    placeholder="Select Job Status"
                                                    className="w-full bgclr"
                                                />

                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="noOfOpenings" className="block">Number of Openings</label>
                                                <InputNumber
                                                    id="openings"
                                                    value={openings}
                                                    onChange={(e) => setOpenings(e.value)}
                                                    placeholder=""
                                                    className="w-full"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="experienceRequired" className="block">Experience Required</label>
                                                <InputNumber
                                                    inputId="totalExperience"
                                                    value={totalExperience}
                                                    onChange={(e) => { setValidationError(""); setTotalExperience(e.value) }}
                                                    placeholder=""
                                                    className="w-full drop-clr"
                                                />
                                                <small className="text-danger">
                                                    {validationError && validationError.includes("Experience") && validationError}
                                                </small>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="d-flex justify-content-between mt-4">
                                                <button type="submit" class="btn btn-primary btn-main">Previous</button>
                                                <button type="submit" class="btn btn-primary btn-main" onClick={nextTab}>Next</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </TabPanel>
                                <TabPanel header="Hiring Details" leftIcon="pi pi-briefcase mr-2">
                                    <Row className="mb-3">
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="hiringManager" className="block">Hiring Manager</label>
                                                <Dropdown
                                                    value={selectedManager}
                                                    onChange={(e) => { setValidationError(""); setSelectedManager(e.value) }}
                                                    options={hiringManagers}
                                                    optionLabel="name"

                                                    placeholder="Select a Hiring Manager"
                                                    className="w-full bgclr"
                                                    filter
                                                    showClear
                                                    filterBy="label"
                                                />
                                                <small className="text-danger">{validationError.includes("Hiring Manager") && validationError}</small>

                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="company" className="block">Company</label>
                                                <Dropdown
                                                    id="company"
                                                    value={selectedCompany}
                                                    options={companies}
                                                    onChange={(e) => setSelectedCompany(e.value)}
                                                    placeholder="Select Company"
                                                    optionLabel="name"

                                                    filter
                                                    filterBy="label" // Enables search by company name
                                                    className="w-full bgclr"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="jobLocation" className="block">Job Location</label>
                                                <Dropdown
                                                    id="jobLocation"
                                                    value={selectedLocation}
                                                    options={jobLocations}
                                                    onChange={(e) => setSelectedLocation(e.value)}
                                                    placeholder="Select Job Location"
                                                    filter
                                                    optionLabel="name"

                                                    filterBy="label"
                                                    className="w-full bgclr"
                                                />
                                            </div>
                                        </Col>

                                    </Row>
                                    <Row className="mb-3">
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="workplaceType" className="block">Workplace Type</label>
                                                <Dropdown
                                                    value={jobworkspace}
                                                    onChange={(e) => setjobworkspace(e.value)}
                                                    options={jobworkspaceview}
                                                    optionLabel="name"

                                                    placeholder="Select Workplace Type"
                                                    className="w-full bgclr"
                                                    filter
                                                    filterBy="label"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="jobType" className="block">Job Type</label>
                                                <Dropdown
                                                    value={jobtype}
                                                    onChange={(e) => setjobtype(e.value)}
                                                    options={jobjobtypeview}
                                                    optionLabel="name"

                                                    placeholder="Select Job Type"
                                                    className="w-full bgclr"
                                                    filter
                                                    filterBy="label"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="minSalary" className="block">Minimum Salary</label>
                                                <InputNumber
                                                    inputId="minSalary"
                                                    value={minSalary}
                                                    onChange={(e) => setMinSalary(e.value)}
                                                    mode="currency"
                                                    currency="INR"
                                                    locale="en-IN"
                                                    placeholder=""
                                                    className="w-full"
                                                />
                                            </div>
                                        </Col>

                                    </Row>
                                    <Row className="mb-3">
                                        <Col lg={3}>
                                            <div className="p-field">
                                                <label htmlFor="maxSalary" className="block">Maximum Salary</label>
                                                <InputNumber
                                                    inputId="maxSalary"
                                                    value={maxSalary}
                                                    onChange={(e) => setMaxSalary(e.value)}
                                                    mode="currency"
                                                    currency="INR"
                                                    locale="en-IN"
                                                    placeholder=""
                                                    className="w-full"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={3}>
                                            <div className="p-field">
                                                <label htmlFor="department" className="block">Department</label>
                                                <Dropdown
                                                    id="department"
                                                    value={departitemsval}
                                                    options={departitems}
                                                    onChange={(e) => setdepartitemsval(e.value)}
                                                    optionLabel="name"

                                                    placeholder="Select Department"
                                                    className="w-full bgclr"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="d-flex justify-content-between mt-4">
                                                <button type="submit" class="btn btn-primary btn-main" onClick={previousTab}>Previous</button>
                                                <button type="submit" class="btn btn-primary btn-main" onClick={nextTab}>Next</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </TabPanel>


                                <TabPanel header="Job description" leftIcon="pi pi-file mr-2">

                                    <Row className="mb-3">
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="primarySkills" className="block">Primary Skills</label>

                                                <MultiSelect
                                                    style={{ border: "1px solid #ced4da", borderRadius: "5px", }}
                                                    id="multiSelect"
                                                    className="w-full"
                                                    options={skillsOptions}
                                                    value={selectedprimarySkills}
                                                    onChange={e => { setselectedprimarySkills(e.value) }}
                                                    optionLabel="name"
                                                    optionValue="id"
                                                    placeholder="Select skills"
                                                    display="chip" // Displays selected options as chips
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="secondarySkills" className="block">Secondary Skills</label>
                                                <MultiSelect
                                                    style={{ border: "1px solid #ced4da", borderRadius: "5px", }}
                                                    id="multiSelect"
                                                    className="w-full"
                                                    options={skillsOptions}
                                                    value={selectedSkillsSecondary}
                                                    onChange={e => { setselectedSkillsSecondary(e.value) }}
                                                    optionLabel="name"
                                                    optionValue="id"
                                                    placeholder="Select skills"
                                                    display="chip" // Displays selected options as chips
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="jobFunction" className="block">Job Function</label>
                                                <Dropdown
                                                    value={selectedJobFunction}
                                                    onChange={(e) => setSelectedJobFunction(e.value)}
                                                    options={jobFunctions}
                                                    optionLabel="name"

                                                    placeholder="Select a Job Function"
                                                    className="w-full bgclr"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col lg={4}>
                                            <div className="p-field">
                                                <label htmlFor="seniority" className="block">Seniority</label>
                                                <Dropdown
                                                    value={selectedSeniority}
                                                    onChange={(e) => setSelectedSeniority(e.value)}
                                                    options={seniorityLevels}
                                                    optionLabel="name"

                                                    placeholder="Select Seniority Level"
                                                    className="w-full bgclr"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6}>
                                            <div className="sidebar d-flex align-items-center justify-content-between mb-2">
                                                <label htmlFor="description" className="block">Description</label>
                                                {/* <InputTextarea
                                                    id="description"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    placeholder="Enter job description"
                                                    rows={5} // Number of visible rows
                                                    cols={30} // Width of the textarea
                                                    className="block w-full"
                                                /> */}
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button color="primary" className="btn btn-primary aibtn">
                                                        <i class="pi pi-star me-1"></i>
                                                        Write with AI
                                                    </Button>
                                                </div>
                                            </div>

                                            <div className="p-field mb-0">
                                                <Editor value={content} onTextChange={handleEditorChange} headerTemplate={header} style={{ height: '240px' }}
                                                    className="w-full" />

                                            </div>
                                            <div style={{ marginTop: "10px", textAlign: "right" }}>
                                                <span>
                                                    {/* {currentWordCount}/{maxWords} words */}
                                                </span>
                                            </div>

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="d-flex justify-content-between mt-4">
                                                <button type="submit" class="btn btn-primary btn-main" onClick={previousTab}>Previous</button>
                                                <button type="submit" class="btn btn-primary btn-main" onClick={nextTab}>Next</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </TabPanel>

                                <TabPanel header="Screening Questions" leftIcon="pi pi-question-circle mr-2">
                                    <Row className="mb-2">
                                        <Col>
                                            <p>We suggest including at least three questions. Applicants are required to answer all questions.</p>
                                            <div>
                                                <div className="block d-flex align-items-center justify-content-end">
                                                    {/* <a
                                                                                               color="primary"
                                                                                               className="anchr-title mb-2"
                                                                                               onClick={handleAddQuestion}
                                                                                               style={{ cursor: "pointer" }}
                                                                                           >
                                                                                               <i className="pi pi-plus me-1"></i> Add Questions
                                                                                           </a> */}
                                                    <button type='button' className='btn addNewDeptBtn btn-outline-primary waves-effect' id='addNewDesigantionNameBtn' onClick={() => addFormFields()}>
                                                        <span>
                                                            add
                                                            <i className='fa fa-plus' aria-hidden='true'></i>
                                                        </span>
                                                        <small className='addBtnText'> </small>
                                                    </button>
                                                </div>

                                                {/* Render dynamic question cards */}

                                                {formValues.map((question, index) => (
                                                    question.is_deleted === false && (
                                                        <div className="mb-2" key={index}>
                                                            <label htmlFor={`question-${index}`} className="form-field-label">
                                                                Question
                                                                <InputText
                                                                    className={`form-control ${question.haveError && "invalid"}`}
                                                                    value={question.section1}
                                                                    onChange={(e) => handleChange(index, "section1", e.target.value)}
                                                                />
                                                            </label>
                                                            <Row className="mb-3">
                                                                <Col xl={4}>
                                                                    <label htmlFor={`skill-${index}`} className="block">
                                                                        Skill *
                                                                    </label>
                                                                    <InputText
                                                                        className={`form-control ${question.haveError && "is-invalid"}`}
                                                                        value={question.skills}
                                                                        onChange={(e) => handleChange(index, "skills", e.target.value)}
                                                                        placeholder="Enter skill"
                                                                    />
                                                                </Col>
                                                                <Col xl={4}>
                                                                    <label htmlFor={`idealAnswer-${index}`} className="block">
                                                                        Ideal Answer (Minimum)
                                                                    </label>
                                                                    <InputText
                                                                        className={`form-control ${question.haveError && "is-invalid"}`}
                                                                        value={question.idealAnswer}
                                                                        onChange={(e) => handleChange(index, "idealAnswer", e.target.value)}
                                                                        placeholder="Enter ideal answer"
                                                                    />
                                                                </Col>
                                                                <Col xl={4}>
                                                                    <div className="d-flex align-items-center mt-4">
                                                                        <Checkbox
                                                                            inputId={`qualification-${index}`}
                                                                            checked={question.qualification}
                                                                            onChange={(e) => handleChange(index, "qualification", e.checked)}
                                                                        />
                                                                        <label htmlFor={`qualification-${index}`} className="ms-2 mt-1">
                                                                            Must Have Qualification
                                                                        </label>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <div className="d-flex justify-content-end">
                                                                <Button
                                                                    icon="pi pi-times"
                                                                    className="p-button-danger"
                                                                    onClick={() => removeFormFields(formValues[index].question_id)} // Pass question_id
                                                                >
                                                                    Remove
                                                                </Button>
                                                            </div>
                                                            {question.haveError && <small className="text-danger">{questionError}</small>}
                                                        </div>
                                                    )
                                                ))}


                                            </div>


                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={12}>
                                            <div className="d-flex justify-content-between mt-4">
                                                <button type="submit" class="btn btn-primary btn-main" onClick={previousTab}>Previous</button>
                                                <button type="submit" class="btn btn-primary btn-main" onClick={handleSubmit1}>Preview</button>
                                            </div>
                                        </Col>
                                    </Row>

                                </TabPanel>

                            </TabView>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div>
                                <Dialog className="details-dialog" header="Review Your Details" visible={showDialog} onHide={handleCloseDialog}
                                    breakpoints={{ '960px': '75vw' }} style={{ width: '60vw' }}>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="card p-4">
                                                {formData && (
                                                    <div className="card p-4">
                                                        <Row className="d-flex justify-content-between">
                                                            <Col lg={6}>
                                                                {/* <p className="mb-1">Job Title</p>
                                                                 */}

                                                                <div>
                                                                    <p className="mb-1">ID:{formData.jobId}</p>
                                                                    <h4 className="pre-txthead me-2">{formData.company}</h4>

                                                                </div>

                                                                <div>
                                                                    <Button className="idbtn me-2">{formData.jobStatus}</Button>
                                                                    <Button className="openbtn me-2">{formData.openings} Openings</Button>
                                                                    <Button className="idbtn">{formData.jobworkspace}</Button>
                                                                </div>
                                                            </Col>

                                                            <Col lg={6} className="d-flex justify-content-end">
                                                                <div>
                                                                    <p className="mb-1">Salary Range</p>
                                                                    <strong>
                                                                        ₹{formData.minSalary?.toLocaleString()} - ₹{formData.maxSalary?.toLocaleString()}
                                                                    </strong>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                )}

                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="card p-4">
                                                <Row className="d-flex justify-content-between">
                                                    <Col lg={12}>

                                                        <Row>
                                                            <Col lg={12}>
                                                                <div className="card p-4">

                                                                    <div className="d-flex">
                                                                        <div>
                                                                            <i class="pi pi-info-circle me-2 diaicon"></i>
                                                                        </div>
                                                                        <h4 className="pre-txthead">Basic Information</h4>
                                                                    </div>

                                                                    {basicinformation.map((f, i) =>
                                                                        formData[f.key] ? (
                                                                            <div key={i} className="mb-3">
                                                                                <label className="fw-bold text-dark">{f.label}</label>
                                                                                <div>{f.isArray ? formData[f.key].join(", ") : `${f.prefix || ""}${formData[f.key]}${f.suffix || ""}`}</div>
                                                                            </div>
                                                                        ) : null
                                                                    )}

                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="card p-4">
                                                <Row className="d-flex justify-content-between">
                                                    <Col lg={12}>
                                                        <div className="d-flex">
                                                            <div>
                                                                <i className="pi pi-map-marker me-2 diaicon"></i>

                                                            </div>
                                                            <h4 className="pre-txthead">Location & Contact</h4>
                                                        </div>

                                                        {location.map((f, i) =>
                                                            formData[f.key] ? (
                                                                <div key={i} className="mb-3">
                                                                    <label className="fw-bold text-dark">{f.label}</label>
                                                                    <div>{f.isArray ? formData[f.key].join(", ") : `${f.prefix || ""}${formData[f.key]}${f.suffix || ""}`}</div>
                                                                </div>
                                                            ) : null
                                                        )}

                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="card p-4">
                                                <Row className="d-flex justify-content-between">
                                                    <Col lg={12}>
                                                        <div className="d-flex">
                                                            <div>
                                                                <i className="pi pi-check-circle me-2 diaicon"></i>
                                                            </div>
                                                            <h4 className="pre-txthead">Skills</h4>
                                                        </div>


                                                        {jobskills.map((f, i) =>
                                                            formData[f.key] ? (
                                                                <div key={i} className="mb-3">
                                                                    <label className="fw-bold text-dark">{f.label}</label>
                                                                    <div>{f.isArray ? formData[f.key].join(", ") : `${f.prefix || ""}${formData[f.key]}${f.suffix || ""}`}</div>
                                                                </div>
                                                            ) : null
                                                        )}

                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="card p-4">
                                                <Row className="d-flex justify-content-between">
                                                    <Col lg={12}>
                                                        <div className="d-flex">
                                                            <div>
                                                                <i className="pi pi-book me-2 diaicon"></i>
                                                            </div>
                                                            <h4 className="pre-txthead">Job Description</h4>
                                                        </div>

                                                        {jobdescription.map((f, i) =>
                                                            formData[f.key] ? (
                                                                <div key={i} className="mb-3">
                                                                    <label className="fw-bold text-dark">{f.label}</label>
                                                                    <div>{f.isArray ? formData[f.key].join(", ") : `${f.prefix || ""}${formData[f.key]}${f.suffix || ""}`}</div>
                                                                </div>
                                                            ) : null
                                                        )}

                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="card p-4">
                                                <Row className="d-flex justify-content-between">
                                                    <Col lg={12}>
                                                        <div className="d-flex">
                                                            <div>
                                                                <i className="pi pi-question-circle me-2 diaicon"></i>
                                                            </div>
                                                            <h4 className="pre-txthead">Screening Questions</h4>
                                                        </div>
                                                        <div>

                                                            <div className="card mt-4 p-3">

                                                                {Array.isArray(formData?.screeningQuestions) && formData.screeningQuestions.length > 0 && (
                                                                    <div className="card mt-4 p-3">
                                                                        {formData.screeningQuestions.map((q, idx) => (
                                                                            <div className="mb-3 border-bottom pb-2" key={idx}>
                                                                                <div><strong>Question:</strong> {q.question}</div>
                                                                                <div><strong>Answer:</strong> {q.experience}</div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}

                                                            </div>

                                                        </div>

                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>


                                    <div className="d-flex justify-content-between mt-4">
                                        <button type="submit" class="btn btn-primary btn-main" onClick={handleSubmit}>Submit</button>
                                    </div>
                                </Dialog>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <footer className="footer footer-back detailsformfooter">
                <Container fluid={true}>
                    <Row className="d-flex">
                        <Col lg={6} md={6} xs={12}>
                            <p className="d-flex justify-content-start mb-0"> &copy; 2025 ATS System. All rights reserved.</p>
                        </Col>
                        <Col lg={6} md={6} xs={12}>
                            <div className="d-flex justify-content-start justify-content-md-end">
                                <p className="me-3 mb-0">Privacy Policy</p>
                                <p className="me-3 mb-0">Terms of Service</p>
                                <p className="mb-0">Contact</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>

        </React.Fragment>
    )
}

export default Jobsdetails;
